import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class CommonValidatorService {

  constructor(private translocoService: TranslocoService) { }

  validateLength(input: string, min: number = 1, max: number = 255, required: boolean = true): string | null {
    if (!input || input.trim().length === 0) {
      return required ? this.translocoService.translate('shared.validators.common.required') : null;
    }

    if (input.length < min) {
      return this.translocoService.translate('shared.validators.common.min', { number: min });
    }

    if (input.length > max) {
      return this.translocoService.translate('shared.validators.common.max', { number: max });
    }
    return null;
  }

  validateDate(date: string, required: boolean = true): string | null {
    const datePattern = /^(0?[1-9]|[12]\d|3[01])\/(0?[1-9]|1[0-2])\/\d{4}$/; // DD/MM/YYYY

    if ((!date || date.trim().length === 0) && !required) {
      return null;
    }

    if (!datePattern.test(date.trim())) {
      return this.translocoService.translate('shared.validators.common.date');
    }
    return null;
  }

  validateNumber(input: string, min: number = Number.MIN_SAFE_INTEGER, max: number = Number.MAX_SAFE_INTEGER, isInteger: boolean = false, required: boolean = true): string | null {
    if (!input || input.trim().length === 0) {
      return required ? this.translocoService.translate('shared.validators.common.required') : null;
    }

    const parsedNumber = isInteger ? parseInt(input.trim(), 10) : parseFloat(input.trim());

    if (isNaN(parsedNumber)) {
      return this.translocoService.translate('shared.validators.common.invalid_number');
    }

    if (parsedNumber < min) {
      return this.translocoService.translate('shared.validators.common.min_number', { number: min });
    }

    if (parsedNumber > max) {
      return this.translocoService.translate('shared.validators.common.max_number', { number: max });
    }

    if (isInteger && !Number.isInteger(parsedNumber)) {
      return this.translocoService.translate('shared.validators.common.integer_required');
    }

    return null;
  }

  validateRecommendedField (input: string, required: boolean = true): string | null {
    if (!input || input.trim().length === 0) {
      return required ? this.translocoService.translate('shared.validators.common.mandatory_field') : null;
    }

    return null;
  }
}
